import React from "react";

/* DICOM Overlay Plane toggle: a scanner-drawn graphic layered over an image. */
const DicomOverlayPlane = ({ color = "#FFFFFF" }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* The image frame */}
    <rect
      x="2"
      y="3.5"
      width="18"
      height="15"
      rx="1.5"
      stroke={color}
      strokeWidth="1.3"
      opacity="0.55"
    />
    {/* The overlay graphic sitting on top of it */}
    <line x1="5.5" y1="8" x2="13" y2="8" stroke={color} strokeWidth="1.4" />
    <line x1="5.5" y1="11.5" x2="16" y2="11.5" stroke={color} strokeWidth="1.4" />
    <line x1="5.5" y1="15" x2="11" y2="15" stroke={color} strokeWidth="1.4" />
    <circle cx="17.5" cy="8" r="1.4" fill={color} />
  </svg>
);

export default DicomOverlayPlane;
